module.exports = __webpack_public_path__ + "img/w1_4.3eb74873.png";